/**
 * @class Oskari.catalogue.bundle.metadataflyout.request.ShowMetadataRequest
 *
 * A Class that may be used as a request to show metadata for the given
 * metadata uuid or RS_Identifier Code / RS_Identifier CodeSpace
 *
 * additionalMetadata is used to show some related metadata in addition to the main metadata
 *
 */
Oskari.clazz.define('Oskari.catalogue.bundle.metadataflyout.request.ShowMetadataRequest', /* constructor */
function (config, additionalMetadata) {
  this._creator = null;
  this._uuid = config.uuid;
  this._layerId = config.layerId;
  this._RS_Identifier_Code = config.RS_Identifier_Code;
  this._RS_Identifier_CodeSpace = config.RS_Identifier_CodeSpace;
  this._additionalMetadata = additionalMetadata;
  this._allMetadata = [];
  if (!(config.uuid === undefined && config.layerId === undefined && config.RS_Identifier_Code === undefined && config.RS_Identifier_CodeSpace === undefined)) {
    this._allMetadata.push(config);
  }
  if (additionalMetadata) {
    this._additionalMetadata = additionalMetadata;
    var n;
    for (n = 0; n < additionalMetadata.length; n += 1) {
      this._allMetadata.push(additionalMetadata[n]);
    }
  }
}, {
  __name: 'catalogue.ShowMetadataRequest',
  getName: function getName() {
    return this.__name;
  },
  getUuid: function getUuid() {
    return this._uuid;
  },
  getLayerId: function getLayerId() {
    return this._layerId;
  },
  getRS_Identifier_Code: function getRS_Identifier_Code() {
    return this._RS_Identifier_Code;
  },
  getRS_Identifier_CodeSpace: function getRS_Identifier_CodeSpace() {
    return this._RS_Identifier_CodeSpace;
  },
  getAdditionalMetadata: function getAdditionalMetadata() {
    return this._additionalMetadata;
  },
  getAllMetadata: function getAllMetadata() {
    return this._allMetadata;
  }
}, {
  protocol: ['Oskari.mapframework.request.Request']
});